module.exports = __webpack_public_path__ + "js/stellarium-web-engine.59d74e78.wasm";